// src/components/WeeklyLessonPlanRow/WeeklyLessonPlanRow.jsx
import React from 'react';
import styles from './WeeklyLessonPlanRow.module.css';
import { FaUserAlt, FaRegCommentDots, FaTrashAlt, FaShareAlt, FaRegComments } from 'react-icons/fa';
import IconAndName from '../IconAndName/IconAndName'; // adjust path if needed
import { GoShareAndroid } from "react-icons/go";
import { MdOutlineDelete } from "react-icons/md";
const WeeklyLessonPlanRow = ({
  month = 'June',
  day = '03',
  subject = '',
  subjectColorVar = 'Success_Color', // CSS var name e.g. --Success_Color
  students = 0,
  notes = 0,
  onAdd = () => {},
  onShare = () => {},
  onDelete = () => {},
  className = '',
}) => {
  const pillStyle = subject
    ? {
        backgroundColor: `var(--${subjectColorVar})`,
        boxShadow: '0 8px 20px rgba(0,0,0,0.04)',
      }
    : {};

  return (
    <div className={`${styles.row} ${className}`}>
      {/* Left Date */}
      <div className={styles.dateCol}>
        <div className={styles.month}>{month}</div>
        <div className={styles.day}>{day}</div>
      </div>

      {/* Middle Subject Pill */}
      <div className={styles.centerCol}>
        {subject ? (
          <div className={styles.pillWrapper}>
            <div className={styles.pill} style={pillStyle}>
              <div className={styles.subject}>{subject}</div>

              <div className={styles.meta}>
                <div className={styles.metaItem}>
                  <FaUserAlt size={17} />
                  <span className={styles.metaText}>{students}</span>
                </div>

                <div className={styles.metaItem}>
                  <FaRegComments size={20} />
                  <span className={styles.metaText}>{notes}</span>
                </div>

                <button
                  className={styles.deleteBtn}
                  onClick={onDelete}
                  aria-label="delete"
                >
                  <MdOutlineDelete size={23} />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.emptyPlaceholder} />
        )}
      </div>

      {/* Right Buttons */}
      <div className={styles.rightCol}>
        <IconAndName
          title="Add Lesson"
          onClick={onAdd}
          bgColor="Primary_Color"
        />
        <button
          className={styles.shareBtn}
          onClick={onShare}
          aria-label="share"
        >
          <GoShareAndroid size={24} />
        </button>
      </div>
    </div>
  );
};

export default WeeklyLessonPlanRow;
